import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { ICommonRoutePropsParam } from 'src/utils/routerSupportTypes';
import PwrPasswordChangeContainer from '../../containers/PwrPasswordChange';

/**
 *
 */
export interface IPasswordChangeRoutePropsParam extends ICommonRoutePropsParam {
	authKey: string;
}

/**
 * パスワードリマインダのパスワード変更
 * @param props
 */
const PasswordChange: React.FC<
	RouteComponentProps<IPasswordChangeRoutePropsParam>
> = ({
	match: {
		params: { authKey, company_code },
	},
}) => {
	return (
		<React.Fragment>
			<PwrPasswordChangeContainer
				authKey={authKey}
				companyCode={company_code}
			/>
		</React.Fragment>
	);
};

export default PasswordChange;



// WEBPACK FOOTER //
// ./src/pages/pwr/PasswordChange.tsx